import axios from "axios";
import api from "./api";

// getTemplates
export const listEmailTemplates = async (obj?: object | null) => {
  const response = await api.get("email-p1-:stage/:stage/crm/getTemplates", {
    params: { ...obj },
  });

  return response.data;
};

// editTemplate
export const updateTemplate = async (template) => {
  const response = await api.put(
    "email-p1-:stage/:stage/crm/putTemplate",
    template
  );

  return response.data;
};

// saveTemplate
export const saveTemplate = async (template) => {
  const response = await api.post(
    "email-p1-:stage/:stage/crm/postTemplate",
    template
  );

  return response.data;
};

// deleteTemplate
export const deleteTemplate = async (id_template) => {
  const response = await api.put("email-p1-:stage/:stage/crm/deleteTemplate", {
    id_template,
  });

  return response.data;
};

export const getHtmlTemplate = async (url: string): Promise<string> => {
  const response = await axios.get(url);

  return response.data;
};
